<script setup lang="ts">
const { t } = useI18n()

const props = defineProps<{
  modelValue?: boolean
}>()

const { isSupportConnection } = useLocalStorage()

const isVisible = computed(() => props.modelValue || isSupportConnection.value)
</script>

<template>
  <div class="flex items-center gap-2">
    <slot />

    <BaseChip v-if="isVisible" :text="t('global.words.assistance')" color="blue" size="sm" />
  </div>
</template>
